<template>
  <div class="top-bar">
    <div class="top-bar__head">
      <button aria-label="back" @click="$emit('back')">
        <div class="back">
          <back-icon class="back__icon" alt="Go back" />
          <div class="back__text">
            <slot name="text" />
          </div>
        </div>
      </button>
      <slot />
    </div>
    <filter-badges v-if="withBadges" />
  </div>
</template>

<script>
import FilterBadges from "@/components/results/FilterBadges/FilterBadges.vue";
import BackIcon from "@/assets/images/back.svg";

export default {
  name: "BaseTopBar",
  components: {
    BackIcon,
    FilterBadges
  },
  props: {
    withBadges: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss" scoped>
.top-bar {
  padding: 10px;

  &__head {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}

.back {
  display: flex;
  align-items: center;

  &__icon {
    height: 14px;
    padding: 10px;
    fill: $color-blue-300;
  }

  &__text {
    display: none;
  }
}

@media screen and (min-width: $media-m) {
  .back__text {
    display: block;
    color: $color-blue-300;
    margin-left: 20px;
  }
}
</style>
